
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface GetCompanyComplianceDetailsRequest {
    companyId: string;
}

/**
 * 
 */
export class ComplianceAdminSupportApi extends runtime.BaseAPI {

    /**
          */
    async getCompanyComplianceDetailsRaw(requestParameters: GetCompanyComplianceDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<{ [key: string]: any; }>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompanyComplianceDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<{ [key: string]: any; }>({
            path: `/compliance/api/admin/{companyId}/compliance-details`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async getCompanyComplianceDetails(requestParameters: GetCompanyComplianceDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCompanyComplianceDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
